/* eslint-disable max-len */
import React, { FC } from "react";

type IProps = {
  width?: number;
  height?: number;
};

const SvgComponent: FC<IProps> = ({ width = 24, height = 24 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Custom Icons">
      <path
        id="sound_detection_dog_barking"
        d="M5.85 21.15C5.29772 21.15 4.85 20.7023 4.85 20.15V11.95L4.5 11.6C4.33333 11.4333 4.20833 11.2417 4.125 11.025C4.04167 10.8083 4 10.5833 4 10.35C4 10.1167 4.04167 9.89567 4.125 9.687C4.20833 9.479 4.33333 9.29167 4.5 9.125L7.40664 6.19565C7.5944 6.00643 7.84993 5.9 8.11649 5.9H11.45L14.6429 2.70711C15.0334 2.31658 15.6666 2.31658 16.0571 2.70711L17.225 3.875C17.875 4.525 18.3707 5.25833 18.712 6.075C19.054 6.89167 19.225 7.75 19.225 8.65C19.225 9.55 19.054 10.4083 18.712 11.225C18.3707 12.0417 17.875 12.775 17.225 13.425L15.1 15.55V20.15C15.1 20.7023 14.6523 21.15 14.1 21.15H5.85ZM6.35 19.65H13.6V14.925L16.15 12.375C16.65 11.8583 17.0373 11.2833 17.312 10.65C17.5873 10.0167 17.725 9.35 17.725 8.65C17.725 7.95 17.5873 7.28733 17.312 6.662C17.0373 6.03733 16.65 5.46667 16.15 4.95L15.35 4.125L12.075 7.4H8.325L7.5 8.225L9.35 10.075C9.8 10.525 10.1457 11.0373 10.387 11.612C10.629 12.1873 10.75 12.7917 10.75 13.425C10.75 14.0083 10.646 14.575 10.438 15.125C10.3533 15.3482 10.2529 15.5618 10.1367 15.7658C9.85635 16.2579 9.19115 16.2688 8.78906 15.8699L6.35 13.45V19.65Z"
        fill="#D6C7BA"
      />
    </g>
  </svg>
);

export default SvgComponent;
